import collapse from '@core/assets/v2/icons/arrows/regular/Icon-Collapse-Regular.svg'
import download from '@core/assets/v2/icons/arrows/regular/Icon-Download-Regular.svg'
import expand from '@core/assets/v2/icons/arrows/regular/Icon-Expand-Regular.svg'
import minus from '@core/assets/v2/icons/math/regular/Icon-Minus-Large-Regular.svg'
import plus from '@core/assets/v2/icons/math/regular/Icon-Plus-Large-Regular.svg'
import close from '@core/assets/v2/icons/math/regular/Icon-X-Large-Regular.svg'
import { createIcon } from '@core/components/v2/Icon/createIcon'

import print from './assets/Icon-Print-Regular.svg'
import stars from './assets/Icon-Stars-Regular.svg'

const icons = {
    close: createIcon(close, 'PreviewClose'),
    minus: createIcon(minus, 'PreviewMinus'),
    plus: createIcon(plus, 'PreviewPlus'),
    expand: createIcon(expand, 'PreviewExpand'),
    collapse: createIcon(collapse, 'PreviewCollapse'),
    download: createIcon(download, 'PreviewDownload'),
    print: createIcon(print, 'PreviewPrint'),
    stars: createIcon(stars, 'PreviewStars'),
}

export function PreviewIcon({ name }: { name: keyof typeof icons | 'file' }) {
    if (name === 'file')
        return (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M14 2H5v20h14V7l-5-5v5h5M12 11v4M12 18h.01"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    const Icon = icons[name]
    return <Icon size={18} color="currentColor" />
}
